import * as React from "react"
import type { SVGProps } from "react"
const SvgReviewSourceTrustpilot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    viewBox="0 0 100 100"
    {...props}
  >
    <path
      fill="currentColor"
      d="m50.014 68.353 15.684-4.064L72.28 84.53zL27.774 84.53l8.493-26.19L14 42.163l27.521.026L50.014 16l8.491 26.19H86L63.76 58.366z"
    />
  </svg>
)
export default SvgReviewSourceTrustpilot
